import { FieldTypes } from "../../formik-form-components/FormikFormLine/constants";
import React, { SyntheticEvent, useEffect } from "react";
import { SearchBarContainer, SearchBarInput } from "./SearchBarStyles";
import { useAppSelector } from "../../../utils/hooks/store";
import { useUpdateSearch } from "../../../utils/hooks/partSearch";
import { useStringInput } from "../../../utils/hooks/inputs";
import Icon from "../../common/Icon";

export default function SearchBar({
  updatePath,
  placeholder,
  inputRef,
}: {
  updatePath?: boolean;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}) {
  const { loading, searchParameters } = useAppSelector(
    (state) => state.componentSearch,
  );
  const updateSearch = useUpdateSearch();

  const {
    value: searchTerms,
    setValue: setSearchTerms,
    bind: bindSearchTerms,
  } = useStringInput(searchParameters?.searchTerms || "");

  useEffect(() => {
    setSearchTerms(
      searchParameters?.searchTerms === undefined
        ? ""
        : searchParameters?.searchTerms,
    );
  }, [searchParameters, setSearchTerms]);

  const handleSubmitSearchForm = (event: SyntheticEvent) => {
    event.preventDefault();
    updateSearch({
      updateSearchParameters: {
        searchTerms,
      },
      updatePath,
    });
  };

  return (
    <form onSubmit={handleSubmitSearchForm}>
      <fieldset disabled={loading}>
        <SearchBarContainer>
          <Icon src={"/icons/search.svg"} alt={"search"} />
          <SearchBarInput
            type={FieldTypes.text}
            placeholder={placeholder || "Search components"}
            ref={inputRef}
            {...bindSearchTerms}
          />
        </SearchBarContainer>
      </fieldset>
    </form>
  );
}
